import { isValidPhoneNumber } from 'react-phone-number-input'
import { z } from 'zod'

export const emailField = z
  .string()
  .min(1, 'Email is required')
  .pipe(z.email('Enter a valid email'))

export const passwordField = z
  .string()
  .min(1, 'Password is required')
  .min(8, 'Password must be at least 8 characters')
  .regex(/[a-z]/, 'Password must contain at least 1 lowercase letter')
  .regex(/[A-Z]/, 'Password must contain at least 1 uppercase letter')
  .regex(/\d/, 'Password must contain at least 1 number')

export const confirmPasswordField = z.string().min(1, 'Confirm your password')

export const fullNameField = z
  .string()
  .trim()
  .min(1, 'Full name is required')
  .regex(/^[\p{L}\s'-]+$/u, 'Name can contain only letters')
  .refine(
    value => {
      const words = value.split(/\s+/).filter(Boolean)

      return words.length >= 2 && words.every(word => word.length >= 2)
    },
    { message: 'Enter both first and last name (at least 2 characters each)' },
  )

export const companyNameField = z
  .string()
  .trim()
  .min(1, 'Company name is required')
  .regex(
    /^[A-Za-z0-9 _-]+$/,
    'Only Latin letters, numbers, spaces, "-" and "_" are allowed',
  )

export const phoneField = z
  .string()
  .min(1, 'Phone number is required')
  .refine(value => isValidPhoneNumber(value), {
    message: 'Enter a valid phone number',
  })

export const optionalPhoneField = z
  .string()
  .optional()
  .refine(value => !value || isValidPhoneNumber(value), {
    message: 'Enter a valid phone number',
  })

export const passwordsMatch = (data: {
  password: string
  confirmPassword: string
}): boolean => data.password === data.confirmPassword

export const passwordsMatchError = {
  message: 'Passwords do not match',
  path: ['confirmPassword'],
}
